module.exports = __webpack_public_path__ + "static/media/bistroLaNoi.75b48f71.png";